// extracted by mini-css-extract-plugin
module.exports = {"VideoOverlay":"VideoOverlay_VideoOverlay__u9TMP"};